module.exports = __webpack_public_path__ + "static/media/notificationIcon.7e6a85dc.svg";